import * as yup from "yup";


const EmployeeUploadFormValidationSchema = yup.object().shape({
  file: yup.mixed().required("File is required."),
  name: yup.string().required("configuration name is required."),
  configurationToUse: yup.string().optional(),
  columnHeaders: yup.array().of(yup.object().shape({
    name: yup.string().required("name is required."),
    relatedColumn: yup.string().optional(),
    isTag: yup.boolean().oneOf([false, true])
  })).required("column headers is required"),
  importAction: yup.string().required("Import action is required"),
  lookupHeader: yup.string().required("Lookup header is required"),
  useExistingConfiguration: yup.boolean().oneOf([true, false])
});

export default EmployeeUploadFormValidationSchema;